import React, { useEffect } from "react";
import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";

import LoadingComponent from "../../../../components/Loading";

import { useSelector } from "react-redux";

import { selectUsuarioSeleccionado } from "../../../../redux/reducer/loginReducer";
import EmptyComponent from "../../../../components/EmptyContent";
// import { deleteInquilino, getAlumnos, inquilinoDelete } from '../../../../services/Alumnos';
import { Box, IconButton, TextField, Typography } from "@material-ui/core";
import {
  DataGrid,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { useHistory } from "react-router-dom";
import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import PropTypes from "prop-types";
import { getAlumnosPosibleBaja } from "../../../../services/alumnos";
import Moment from "react-moment";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}

// import Moment from 'react-moment';

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "80px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "90vh",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
    width: "100%",
    flexDirection: "column",
    textAlign: "center",
  },
  emptyImage: {
    width: "100%",
  },
  rootFilter: {
    padding: theme.spacing(0.5, 0.5, 0),
    justifyContent: "space-between",
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  textFieldFilter: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    margin: theme.spacing(1, 0.5, 1.5),
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(0.5),
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  enlace: {
    color: theme.palette.link.main,
    textDecoration: "none",
  },
}));

export default function AlumnosPosibleBajaContent() {
  const classes = useStyles();

  const [Alumnos, setAlumnos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMensaje, setLoadingMensaje] = useState("");

  const usuarioSeleccionado = useSelector((state) => {
    return selectUsuarioSeleccionado(state);
  });
  const history = useHistory();

  /* -------------------------------------------------------------------------- */
  /*                                  UseEffect                                 */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    setLoading(true);
    setLoadingMensaje("Cargando alumnos");

    const usuario_id = usuarioSeleccionado.id;

    getAlumnosPosibleBaja({ usuario_id }).then((response) => {
      response && setAlumnos(response.alumnos);
      setLoading(false);
    });

    // getComerciales({usuario_id: usuario_id}).then( (response) => {
    //     response.comerciales && setComerciales(response.comerciales)
    // })
  }, []);

  /* -------------------------------------------------------------------------- */
  /*                           Definicion de columnas                           */
  /* -------------------------------------------------------------------------- */

  const columnas = [
    { field: "id", hide: false, headerName: "ID" },
    { field: "nombre", headerName: "Nombre", minWidth: 150, flex: 1 },
    { field: "especialidad_nombre", headerName: "Especialidad", minWidth: 220 },
    {
      field: "comunidad_autonoma_nombre",
      headerName: "Comunidad",
      minWidth: 220,
    },

    {
      field: "alumno_desde",
      width: 120,
      headerName: "Alumno desde",
      description: "Alumno desde",
      type: "date",
      renderCell: (cellValues) => {
        return cellValues.value !== null &&
          cellValues.value !== "0000-00-00 00:00:00" ? (
          <Moment format="DD/MM/YYYY">{cellValues.value}</Moment>
        ) : (
          <></>
        );
      },
    },
    {
      field: "fecha_posible_baja",
      width: 120,
      headerName: "Fecha posible baja",
      description: "Fecha posible baja",
      type: "date",
      renderCell: (cellValues) => {
        return cellValues.value !== null &&
          cellValues.value !== "0000-00-00 00:00:00" ? (
          <Moment format="DD/MM/YYYY">{cellValues.value}</Moment>
        ) : (
          <></>
        );
      },
    },
    { field: "motivo_baja_nombre", headerName: "Motivo Baja", minWidth: 220 },
    { field: "motivo_baja", headerName: "Motivo baja", minWidth: 120, flex: 1 },
    { field: "grupo_nombre", headerName: "Grupo", minWidth: 120, flex: 1 },
    { field: "tutor_nombre", headerName: "Tutor", minWidth: 120, flex: 1 },
    {
      field: "es_baja_tutea",
      headerName: "Baja tutea",
      minWidth: 220,
      renderCell: (cellValues) => {
        return cellValues.row.es_baja_tutea === "1" ? "SI" : "NO";
      },
    },
    { field: "comercial_nombre", headerName: "Comercial", minWidth: 120 },
    // {
    //   field: 'actions',
    //   type: 'actions',
    //   width: 80,
    //   getActions: (params) => [
    //     <GridActionsCellItem
    //       icon={<EditIcon />}
    //       label="Modificar"
    //       component={Link}
    //       to={`alumnos/detalle/${params.id}`}
    //       showInMenu
    //     />,
    //   ],
    // }
  ];

  /* -------------------------------------------------------------------------- */
  /*                                  Contenido                                 */
  /* -------------------------------------------------------------------------- */
  function QuickSearchToolbar(props) {
    const classes = useStyles();

    return (
      <div className={classes.rootFilter}>
        <div>
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
          <GridToolbarExport
            csvOptions={{ disableToolbarButton: false }}
            printOptions={{ disableToolbarButton: true }}
          />
        </div>
        <TextField
          variant="standard"
          value={props.value}
          onChange={props.onChange}
          placeholder="Buscar…"
          className={classes.textFieldFilter}
          InputProps={{
            startAdornment: <SearchIcon fontSize="small" />,
            endAdornment: (
              <IconButton
                title="Clear"
                aria-label="Clear"
                size="small"
                style={{ visibility: props.value ? "visible" : "hidden" }}
                onClick={props.clearSearch}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            ),
          }}
        />
      </div>
    );
  }

  QuickSearchToolbar.propTypes = {
    clearSearch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  };

  const Contenido = () => {
    const [rows, setRows] = React.useState(Alumnos);
    const [searchText, setSearchText] = React.useState("");
    const requestSearch = (searchValue) => {
      // console.log(searchValue)
      setSearchText(searchValue);
      const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
      // const searchRegex = new RegExp(`.*${searchValue}.*`, 'ig');
      const filteredRows = Alumnos.filter((row) => {
        return Object.keys(row).some((field) => {
          // console.log(field)
          // console.log(row)
          return searchRegex.test(row[field]);
        });
      });
      setRows(filteredRows);
    };

    const handleAlumnoDetalle = (id) => {
      history.push("alumnos/detalle/" + id);
    };

    const [expandedAccordion, setExpandedAccordion] = React.useState("panel1");

    const handleAccordionChange = (panel) => (event, isExpanded) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

    return rows ? (
      <>
      <Box mt={12} mx={2}>
        <Typography
        variant="h5"
        component="h3"
        gutterBottom
        display="inline"
        style={{ fontWeight: 500 }}
        >
        {"Alumnos posible baja"}
        </Typography>
      </Box>

      <Box mt={3} mb={3} mx={2}>
        <Accordion
        expanded={expandedAccordion === "panel1"}
        onChange={handleAccordionChange("panel1")}
        >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
          Detalle de Alumnos
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2} style={{ width: "100%" }}>
          {rows.map((alumno) => (
            <Grid item xs={12} sm={12} md={12} key={alumno.id}>
            <Card
              onClick={() => handleAlumnoDetalle(alumno.id)}
              style={{
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            >
              <CardContent>
              <Typography color="textSecondary" gutterBottom>
                [{alumno.id}] {alumno.nombre}
              </Typography>
              <hr />
              <Typography variant="body2">
                <b>Especialidad:</b> {alumno.especialidad_nombre}
              </Typography>
              <Typography variant="body2">
                <b>Comunidad:</b> {alumno.comunidad_autonoma_nombre}
              </Typography>
              <Typography variant="body2">
                <b>Motivo:</b> {alumno.motivo_baja_nombre}
              </Typography>
              <Typography variant="body2">
                <b>Motivo:</b> {alumno.motivo_baja}
              </Typography>
              <Typography variant="body2">
                <b>Tutor:</b> {alumno.tutor_nombre}
              </Typography>
              <Typography variant="body2">
                <b>Grupo: </b> {alumno.grupo_nombre}
              </Typography>
              <Typography variant="body2">
                <b>Alumno desde: </b>
                <Moment format="DD/MM/YYYY">
                {alumno.alumno_desde}
                </Moment>
              </Typography>
              <Typography variant="body2">
                <b>Fecha posible baja: </b>
                <Moment format="DD/MM/YYYY">
                {alumno.fecha_posible_baja}
                </Moment>
              </Typography>

              <Typography
                variant="body2"
                style={{ marginTop: 12, fontWeight: "bold" }}
              >
                <b>Seguimiento: </b>
              </Typography>
              {alumno.seguimiento && alumno.seguimiento.length > 0 ? (
                <table
                style={{
                  width: "100%",
                  marginTop: 8,
                  borderCollapse: "collapse",
                }}
                >
                <thead>
                  <tr style={{ borderBottom: "1px solid #ddd" }}>
                  <th
                    style={{
                    padding: 4,
                    textAlign: "left",
                    fontSize: 12,
                    }}
                  >
                    Usuario
                  </th>
                  <th
                    style={{
                    padding: 4,
                    textAlign: "left",
                    fontSize: 12,
                    }}
                  >
                    Fecha
                  </th>
                  <th
                    style={{
                    padding: 4,
                    textAlign: "left",
                    fontSize: 12,
                    }}
                  >
                    Nota
                  </th>
                  </tr>
                </thead>
                <tbody>
                  {alumno.seguimiento.map((seg, index) => (
                  <tr
                    key={index}
                    style={{ borderBottom: "1px solid #eee" }}
                  >
                    <td style={{ padding: 4, fontSize: 12 }}>
                    {seg.created_usuario_nombre}
                    </td>
                    <td style={{ padding: 4, fontSize: 12 }}>
                    <Moment format="DD/MM/YYYY">
                      {seg.created}
                    </Moment>
                    </td>
                    <td style={{ padding: 4, fontSize: 12 }}>
                    {seg.nota}
                    </td>
                  </tr>
                  ))}
                </tbody>
                </table>
              ) : (
                <Typography variant="caption">
                Sin seguimiento
                </Typography>
              )}
              </CardContent>
            </Card>
            </Grid>
          ))}
          </Grid>
        </AccordionDetails>
        </Accordion>
      </Box>

      <Box mt={2} mb={3} mx={2}>
        <Accordion
        expanded={expandedAccordion === "panel2"}
        onChange={handleAccordionChange("panel2")}
        >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
          Tabla de Datos
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            id="data-grid-alumno-posible-baja"
            pageSize={10}
            onStateChange={(state) => console.log(state)}
            experimentalFeatures={{ newEditingApi: true }}
            rows={rows}
            columns={columnas}
            rowHeight={30}
            components={{ Toolbar: QuickSearchToolbar }}
            onRowDoubleClick={(evento) => handleAlumnoDetalle(evento.id)}
            componentsProps={{
            toolbar: {
              value: searchText,
              onChange: (event) => requestSearch(event.target.value),
              clearSearch: () => requestSearch(""),
              csvOptions: { disableToolbarButton: false },
              printOptions: { disableToolbarButton: false },
            },
            }}
          />
          </div>
        </AccordionDetails>
        </Accordion>
      </Box>
      </>
    ) : (
      <EmptyComponent mensaje="No hay datos para mostrar" />
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                                   Return                                   */
  /* -------------------------------------------------------------------------- */
  return (
    <div className={classes.container}>
      {loading ? (
        <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
      ) : (
        <Contenido />
      )}
    </div>
  );
}
